import { payTicketWithMoney, payTicketWithPoints } from 'pages/OrderSummary/reducer'
import { connect } from 'react-redux'

const hocTicketPayment = (InnerComponent) => connect(null, { payTicketWithPoints, payTicketWithMoney })(InnerComponent)

export default hocTicketPayment
